import React from 'react';
import PieChart from 'react-svg-piechart';
import { breakdownEnrichmentTypes, prepForPie } from '../../util/databaseFunctions';
import { addCommasToBigNumbers } from '../../util/helperFunctions';
import Bold from '../Bold';
import ColorBox from '../ColorBox';
import { Columns } from 'bloomer/lib/grid/Columns';
import { Column } from 'bloomer/lib/grid/Column';
import styled from 'styled-components';
import Spacer from '../Spacer';

const FlexParagraph = styled.p`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export default class PieGraph extends React.Component {
  constructor() {
    super();
    this.state = {
      expandedSector: null,
      pieData: [],
    };
    this.handleMouseEnterOnSector = this.handleMouseEnterOnSector.bind(this);
    this.refresh = this.refresh.bind(this);
  }
  handleMouseEnterOnSector(sector, index) {
    this.setState({ expandedSector: index });
  }
  refresh(props) {
    if (!props.chartName) {
      const brokenDownData = breakdownEnrichmentTypes(props.data);
      const pieData = prepForPie(brokenDownData);
      this.setState({
        pieData: pieData,
      });
    } else {
      this.setState({
        pieData: props.data,
        humanEffortAcc: props.humanEffortAcc,
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.refresh(nextProps);
    }
  }
  componentDidMount() {
    this.refresh(this.props);
  }
  render() {
    const { humanEffortAcc, pieData } = this.state;
    const legendData = humanEffortAcc || pieData;
    return (
      <Columns>
        <Column>
          <PieChart
            data={this.state.pieData}
            expandedSector={this.state.expandedSector}
            onSectorHover={this.handleMouseEnterOnSector}
            sectorStrokeWidth={2}
            expandOnHover
          />
        </Column>
        <Column>
          <ul>
            {legendData.map((element, i) => (
              <li className="color-box-container" key={`pieReportLegend-${this.props.chartName}-${i}`}>
                <FlexParagraph>
                  <ColorBox color={pieData[i].color} />
                  <Spacer
                    className="is-capitalized"
                    style={{
                      fontWeight: this.state.expandedSector === i ? 'bold' : null,
                    }}
                  >
                    {element.label}{' '}
                    <span>
                      : {addCommasToBigNumbers(element.value > 1 ? Math.round(element.value) : element.value)} (
                      <Bold>{((element.value / this.props.totalTime) * 100).toFixed(2)}%</Bold>)
                    </span>
                  </Spacer>
                </FlexParagraph>
              </li>
            ))}
          </ul>
        </Column>
      </Columns>
    );
  }
}
